import { Link } from "react-router-dom";
import { formatINR } from "@/lib/cart";

const ProductCard = ({ product, index = 0 }) => {
  const variants = product.variants || [
    { weight: product.weight || "200g", price: product.price },
  ];
  const minPrice = Math.min(...variants.map((v) => v.price));
  const hasMultiple = variants.length > 1;

  return (
    <Link
      to={`/shop/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="relative overflow-hidden bg-gradient-to-b from-[#161616] to-[#0a0a0a] aspect-[4/5] mb-6">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          style={{ objectPosition: product.image_position || "center" }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/40 via-transparent to-transparent" />
        <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
          <span className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37]">
            View Details
          </span>
          <span className="text-[#D4AF37] text-lg">→</span>
        </div>
        {hasMultiple && (
          <span className="absolute top-4 left-4 px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] text-[#0A0A0A] bg-[#D4AF37]/95 backdrop-blur-sm">
            {variants.map((v) => v.weight).join(" · ")}
          </span>
        )}
      </div>

      <div className="space-y-2">
        <p className="overline">{product.tagline}</p>
        <h3 className="font-heading text-2xl md:text-3xl text-[#F5F5F0] tracking-tight leading-tight group-hover:text-[#D4AF37] transition-colors duration-500">
          {product.name}
        </h3>
        <div className="flex items-baseline justify-between pt-1">
          <span className="text-sm text-[#8A8A85] tracking-wide">
            {hasMultiple ? variants.map((v) => v.weight).join(" · ") : product.weight}
          </span>
          <span className="text-base text-[#F5F5F0] tracking-wider">
            {hasMultiple && (
              <span className="text-xs text-[#8A8A85] mr-1">from</span>
            )}
            {formatINR(minPrice)}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
